import { render, staticRenderFns } from "./userHeader.vue?vue&type=template&id=6d552c74&scoped=true"
import script from "./userHeader.vue?vue&type=script&lang=js"
export * from "./userHeader.vue?vue&type=script&lang=js"
import style0 from "./userHeader.vue?vue&type=style&index=0&id=6d552c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d552c74",
  null
  
)

export default component.exports